import React from "react";
import HeaderHome from "../components/Headers/HeaderHome/HeaderHome";
import DisplayHeader from "../components/Headers/DisplayHeader/DisplayHeader";
import ServiceSection from "../components/ServiceSection/ServiceSection";
import BrandScroller from "../components/BrandScroller/BrandScroller";
import AboutSection from "../components/AboutSection/AboutSection";
import ProjectSection from "../components/ProjectSection/ProjectSection";
import WorkFlowSection from "../components/WorkFlowSection/WorkFlowSection";
import ClientTestimonials from "../components/ClientTestimonials/ClientTestimonials";
import Layout from "../components/Layout/Layout";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <div>
      <Helmet>
         <title>Netario Innovations Pvt. Ltd.</title>
         <meta name="discription" content="Welcome to Netario Innovatives Pvt Ltd, Our mission is to provide high-quality services that help businesses grow online, ensuring they stand out in the competitive digital landscape." />
        <meta name="keywords" content="Netario Innovatives Pvt Ltd" />
        <link rel="canonical" href="https://www.netarioinnovations.com/" />
        
        <meta property="og:title" content="Welcome to Netario Innovatives Pvt Ltd, your trusted partner." />
        <meta property="og:site_name" content="Netario Innovatives Pvt Ltd" />
        <meta property="og:url" content="https://www.netarioinnovations.com/" />
        <meta property="og:description" content="Welcome to Netario Innovatives Pvt Ltd, Our mission is to provide high-quality services that help businesses grow online, ensuring they stand out in the competitive digital landscape." />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://lh3.googleusercontent.com/geougc/AF1QipNWjYsz9DM1V5zlqDwMVyleCQmYMNWx9Dq8cU24=h305-no" />
      
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:domain" content="www.netarioinnovations.com" />
        <meta name="twitter:url" content="https://www.netarioinnovations.com/" />
        <meta name="twitter:title" content="Welcome to Netario Innovatives Pvt Ltd, your trusted partner." />
        <meta name="twitter:description" content="Welcome to Netario Innovatives Pvt Ltd, Our mission is to provide high-quality services that help businesses grow online, ensuring they stand out in the competitive digital landscape." /> 
        <meta name="twitter:image" content="https://lh3.googleusercontent.com/geougc/AF1QipNWjYsz9DM1V5zlqDwMVyleCQmYMNWx9Dq8cU24=h305-no" />
       </Helmet>
          <HeaderHome />
          <DisplayHeader />
          <ServiceSection />
          <BrandScroller />
          <AboutSection />
          <ProjectSection />
          <WorkFlowSection />
          <ClientTestimonials />
        </div>
  );
};

export default Home;
